import { deleteReferenceCitationFromComponents as deleteReferenceCitation } from 'modules/References/services/deleteReferenceCitationFromComponents';
import { batchActions } from 'redux-batched-actions';
import { call, put, select } from 'redux-saga/effects';
import { setDocuments } from 'containers/Documents/actions';
import { documents as documentsSelector } from 'containers/Documents/selectors';
import { setRelations } from 'containers/Relations/actions';
import { layeredRelations as relationsSelector } from 'containers/Relations/selectors';
import * as Models from 'models';
import { handleSagaError } from 'services/handleError';
import { isTextComponent } from 'utils/entityType';
import { Action } from '../models';

export function* deleteReferenceCitationFromComponents(
  action: Action.IDeleteReferenceCitationFromComponents,
): Generator {
  try {
    const { referenceCitationId, textComponentIds } = action.payload;

    const relations = (yield select(relationsSelector)) as ReturnTypeSaga<typeof relationsSelector>;
    const documents = (yield select(documentsSelector)) as ReturnTypeSaga<typeof documentsSelector>;
    const textComponents = documents.filter(isTextComponent) as Models.TextComponentsMap;

    const updatedEntities = (yield call(
      deleteReferenceCitation,
      referenceCitationId,
      textComponents,
      relations,
      textComponentIds,
    )) as ReturnTypeSaga<typeof deleteReferenceCitation>;
    const { updatedDocuments, updatedRelations } = updatedEntities;

    yield put(batchActions([
      setDocuments(Object.assign(documents.toJS() as Models.CombinedDocumentsMap, updatedDocuments)),
      setRelations(Object.assign(relations.toJS() as Models.LayeredRelations, updatedRelations)),
    ]));
  } catch (error) {
    yield call(handleSagaError, error, 'ArtboardCell.deleteReferenceCitationFromComponents', 'DeleteReferenceCitationFromComponents');
  }
}
